export const mapToOptions = (data) =>
  data.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.name,
  }))
